import styled from "styled-components";

type LoadingLogo = {
  position: "top" | "bottom";
  name: string;
};

const Styled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 20%;
  display: flex;
  div {
    z-index: 1;
    background-image: url("/ui/game/images/en/loading-screen/logos/${(
      props: any
    ) => props.name}.webp");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 100%;
    min-width: 65em;
  }
  @media screen and (orientation: portrait) and (max-width: 800px) {
    .top {
      height: 200% !important; 
    }
  }
  .top {
    margin-top: -4em;
    height: 260%;
  }
  .bottom {
    height: 100%;
    max-height: 7em;
    align-self: end;
  }
` as any;

const Logo: React.FC<LoadingLogo> = (props) => {
  return (
    <Styled name={props.name} className="loading-screen-logo">
      <div className={props.position === "bottom" ? "bottom" : "top"}></div>
    </Styled>
  );
};

export default Logo;
